import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router";
export const HeaderContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: "16px 16px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
}));

export type HeaderActionType = {
    name: string;
    icon: React.ReactNode;
    isHidden?: boolean;
    action: () => void; //so far 11-1=19-25 all actions have been reroutes, or don't return anything
}


export default function Header({
    title,
    subtitle,
    titleSize,
    headerActions,
    onBack,
    disableDivider = false,
}: {
    title: string | null;
    subtitle?: string | null | undefined;
    titleSize?: string;
    onBack?: () => void;
    disableDivider?: boolean;
    headerActions?: HeaderActionType[]
}) {
    const navigate = useNavigate();

    const handleBack = () => (onBack ? onBack() : navigate("/dashboard"));
    return (
        <HeaderContainer
            sx={
                disableDivider
                    ? {}
                    : { border: "none", borderBottom: "2px solid rgb(209 213 219)" }
            }
        >
            <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
                {onBack && (
                    <IconButton onClick={handleBack} sx={{ marginRight: "8px" }}>
                        <ChevronLeftIcon />
                    </IconButton>
                )}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant={titleSize as
                        "body1" | "body2" | "button" | "caption" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "overline" || "h4"} sx={{ textAlign: "left" }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Box>
                            <Typography
                                variant="body1"
                                sx={(t: any) => ({ color: t.palette.grey[500], textAlign: "left" })}
                            >
                                {subtitle}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box >
                {headerActions?.map((action, i) => {
                    return (
                        <Box component="div" key={`${action}-${i}`}>
                            <Button
                                sx={{ visibility: action.isHidden ? "hidden" : "visible" }}
                                onClick={action.action} startIcon={action.icon} color="secondary">
                                {action.name}
                            </Button>
                        </Box>
                    )
                })}
            </Box>
        </HeaderContainer >
    );
}
